import { EventDetailPage } from '@/features/events/routes/EventDetailPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id')({
  component: EventDetailPage,
});
